<div class="variants-section">
  <div class="form-row">
    <div class="form-control variants-control">
      <div class="checkbox-with-info">
        <app-enfaf-checkbox [control]="hasVariantsControl" color="light">
          Este producto tiene variantes
        </app-enfaf-checkbox>
        <app-enfaf-icon svgIconName="info" [iconSize]="'24px'" />
      </div>
    </div>
  </div>

  @if (hasVariantsControl.value) {
  <div class="variants-form-section">
    <div class="variants-header">
      <h3 class="section-title">Variantes del producto</h3>
    </div>

    <div class="variants-list">
      @for (variantGroup of variantsFormArray.controls; track i; let i = $index) {
      <div class="variant-item">
        <div class="variant-row">
          <div class="field-wrapper">
            <enfaf-input label="Nombre de la variante" placeholder="Introduce el nombre de la variante"
              [control]="variantGroup.get('name')" name="variantName{{i}}" autocomplete="off" color="light"
              [errorLabel]="getVariantNameError(i) || ''">
            </enfaf-input>
          </div>

          <div class="field-wrapper price-with-actions" [class.has-delete-button]="variantsFormArray.length > 1">
            <enfaf-input-suffix label="Precio" type="number" placeholder="Precio" [control]="variantGroup.get('price')"
              step="0.01" min="0" max="10000" suffixIcon="euro-sign"
              description="Si quieres un producto gratuito, introduce 0" name="variantPrice{{i}}" iconSize="'21px'"
              autocomplete="off" color="light" [showNumberSpinners]="false"
              [errorLabel]="getVariantPriceError(i) || ''">
            </enfaf-input-suffix>

            <div class="variant-actions">
              @if (variantsFormArray.length > 1) {
              <div class="delete-variant" (click)="removeVariant(i)" title="Eliminar variante">
                <app-enfaf-icon svgIconName="trash-red" iconSize="24px" />
              </div>
              }
            </div>
          </div>
        </div>
      </div>
      }
    </div>

    <div class="add-variant-section">
      <app-primary-cta-button caption="Añadir variante" type="button" (clickEvent)="addEmptyVariant()" />
    </div>
  </div>
  }
</div>
